export const DownArrow = () => {
    return (
        <svg
            width="23"
            height="18"
            viewBox="0 0 23 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.41211 9H21.3481"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"/>
            <path
                d="M13.9961 1.64893L21.3471 8.99993"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"/>
            <path
                d="M21.3477 9L13.9967 16.351"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"/>
        </svg>
    );

};

export const NextArrow = () => {
  return (
    <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41211 9H21.3481" stroke="white" strokeWidth="2" strokeLinecap="round"></path><path d="M13.9961 1.64893L21.3471 8.99993" stroke="white" strokeWidth="2" strokeLinecap="round"></path><path d="M21.3477 9L13.9967 16.351" stroke="white" strokeWidth="2" strokeLinecap="round"></path></svg>
  );
};

export const GroupIcon = () => {
    return (
        <svg
            width="35"
            height="31"
            viewBox="0 0 35 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21.6224 14.5058C21.6223 15.3011 21.3864 16.0784 20.9446 16.7395C20.5027 17.4007 19.8747 17.916 19.14 18.2203C18.4053 18.5245 17.5969 18.6041 16.8169 18.449C16.037 18.2938 15.3206 17.9109 14.7583 17.3485C14.196 16.7862 13.813 16.0698 13.6579 15.2899C13.5027 14.5099 13.5823 13.7015 13.8865 12.9668C14.1908 12.2321 14.7061 11.6041 15.3673 11.1622C16.0284 10.7204 16.8058 10.4845 17.601 10.4844C18.1291 10.4843 18.6521 10.5883 19.14 10.7904C19.6279 10.9924 20.0713 11.2886 20.4447 11.6621C20.8182 12.0355 21.1144 12.4789 21.3165 12.9668C21.5185 13.4547 21.6225 13.9777 21.6224 14.5058Z"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
            <path
                d="M19.8927 20.9385H15.3079C14.6192 20.9384 13.9372 21.074 13.3009 21.3376C12.6646 21.6011 12.0864 21.9874 11.5994 22.4744C11.1124 22.9614 10.7261 23.5396 10.4626 24.1759C10.199 24.8122 10.0634 25.4942 10.0635 26.183V28.6793C10.0635 28.8854 10.1454 29.0832 10.2912 29.2289C10.4369 29.3747 10.6347 29.4566 10.8408 29.4566H24.3666C24.5727 29.4566 24.7705 29.3747 24.9162 29.2289C25.062 29.0832 25.1439 28.8854 25.1439 28.6793V26.183C25.144 25.4937 25.0082 24.8111 24.7442 24.1743C24.4803 23.5376 24.0934 22.9591 23.6056 22.472C23.1179 21.9849 22.5389 21.5988 21.9018 21.3356C21.2647 21.0725 20.582 20.9375 19.8927 20.9385Z"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
            <path
                d="M13.1229 5.02094C13.1229 5.81612 12.8872 6.59344 12.4454 7.25463C12.0037 7.91583 11.3758 8.4312 10.6412 8.7356C9.90661 9.04 9.09824 9.11974 8.31831 8.96476C7.53838 8.80978 6.82191 8.42703 6.25949 7.8649C5.69707 7.30277 5.31395 6.5865 5.15857 5.80665C5.00319 5.0268 5.08252 4.21839 5.38654 3.48363C5.69055 2.74886 6.20561 2.12073 6.86657 1.67866C7.52754 1.23658 8.30474 1.00041 9.09992 1C9.62813 0.999728 10.1512 1.10353 10.6393 1.30548C11.1274 1.50743 11.5709 1.80357 11.9445 2.17697C12.3181 2.55038 12.6145 2.99373 12.8167 3.48171C13.0189 3.96969 13.1229 4.49273 13.1229 5.02094Z"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
            <path
                d="M11.5186 11.4561C11.4771 11.4561 11.4352 11.4561 11.3932 11.4561H6.80841C6.1199 11.4559 5.4381 11.5914 4.80195 11.8548C4.1658 12.1181 3.58775 12.5042 3.1008 12.9909C2.61385 13.4777 2.22755 14.0556 1.96394 14.6916C1.70034 15.3277 1.56459 16.0094 1.56445 16.6979V19.1932C1.56514 19.3985 1.64698 19.5951 1.79213 19.7403C1.93727 19.8854 2.13394 19.9673 2.3392 19.968H10.236"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
            <path
                d="M22.0781 5.02094C22.0781 5.81625 22.314 6.5937 22.7558 7.25496C23.1977 7.91622 23.8258 8.43159 24.5606 8.7359C25.2953 9.0402 26.1039 9.11977 26.8839 8.96454C27.6639 8.8093 28.3804 8.42624 28.9427 7.8638C29.505 7.30136 29.8878 6.5848 30.0429 5.80475C30.1979 5.02469 30.1181 4.21618 29.8136 3.48147C29.5091 2.74676 28.9936 2.11885 28.3322 1.67715C27.6708 1.23544 26.8933 0.999795 26.098 1C25.0318 1.00027 24.0093 1.42403 23.2555 2.17807C22.5016 2.93211 22.0781 3.9547 22.0781 5.02094Z"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
            <path
                d="M24.9643 19.968H32.8615C32.9633 19.968 33.064 19.9481 33.158 19.9092C33.252 19.8703 33.3374 19.8133 33.4093 19.7414C33.4813 19.6695 33.5384 19.5841 33.5773 19.4901C33.6162 19.3962 33.6363 19.2954 33.6363 19.1937V16.6979C33.6359 15.3075 33.0832 13.9741 32.0998 12.9911C31.1164 12.0081 29.7828 11.4559 28.3923 11.4561H23.8071C23.7656 11.4561 23.7236 11.4561 23.6816 11.4561"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>

    );
};

export const AgentIcon = () => {
    return (
        <svg
            width="27"
            height="29"
            viewBox="0 0 27 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.5123 12.218C14.6101 12.218 17.1213 9.70673 17.1213 6.60898C17.1213 3.51123 14.6101 1 11.5123 1C8.41455 1 5.90332 3.51123 5.90332 6.60898C5.90332 9.70673 8.41455 12.218 11.5123 12.218Z"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
            <path
                d="M14.7136 15.584H8.31525C6.37512 15.584 4.51446 16.3547 3.14259 17.7266C1.77071 19.0984 1 20.9591 1 22.8992V26.3815C1 26.6682 1.11391 26.9432 1.31668 27.146C1.51945 27.3488 1.79446 27.4627 2.08122 27.4627H20.9471C21.2338 27.4627 21.5088 27.3488 21.7116 27.146C21.9144 26.9432 22.0283 26.6682 22.0283 26.3815V22.8992C22.0283 20.9592 21.2577 19.0986 19.8859 17.7268C18.5142 16.3549 16.6536 15.5841 14.7136 15.584Z"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
            <path
                d="M19.2124 12.4746H26.0001"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
            <path
                d="M22.606 9.08105V15.8687"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>
    );
};

export const Signature = () => {
    return (
        <svg
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_118_971"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="32"
                height="33">
                <path d="M31.34 0H0V33H31.34V0Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_118_971)">
                <path d="M29.1511 27.1221H2.77637" stroke="black" strokeMiterlimit="10"/>
                <path
                    d="M18.4802 18.9821C19.3614 19.0035 20.6849 18.4598 21.7709 17.9239C22.9818 17.3215 24.0057 16.4006 24.7325 15.26C25.3812 14.2449 26.0168 13.141 26.639 11.9484C25.6219 11.8844 24.6257 11.6305 23.7019 11.1999C24.6138 11.0531 25.4877 10.7275 26.2734 10.2419C27.3513 9.65199 28.196 8.71239 28.6683 7.57802C29.6875 5.0992 30.5792 2.5699 31.34 0C28.414 0.158718 25.5094 0.592425 22.6646 1.29539C21.8268 1.49818 21.0516 1.90344 20.4069 2.47562C19.7622 3.0478 19.2678 3.76943 18.967 4.57721C18.8819 4.80102 18.8223 5.03371 18.7894 5.27087C18.4632 4.43178 18.2752 3.54538 18.2326 2.64614C16.5853 3.24287 14.9866 3.96583 13.4506 4.8086C11.8996 5.66079 10.7144 7.05164 10.1192 8.71827C9.98868 9.06268 9.90795 9.42394 9.87943 9.79114C9.57016 9.14808 9.34391 8.46829 9.20614 7.76815C5.24737 11.297 3.42861 15.9312 5.71591 21.4977C10.396 25.3985 15.9338 25.094 21.0673 19.9208C20.1587 19.7533 19.2843 19.4356 18.4802 18.9806"
                    fill="black"/>
                <path
                    d="M16.2069 12.0703C15.9248 12.4417 15.6286 12.789 15.3293 13.128C15.03 13.467 14.7391 13.8133 14.4414 14.1445C14.2915 14.3101 14.1452 14.4798 13.9979 14.6465C13.8506 14.8131 13.6991 14.9761 13.5503 15.1401C13.2557 15.4717 12.9637 15.804 12.6649 16.1268C11.4871 17.4362 10.3259 18.7337 9.19297 20.0547C8.06002 21.3757 6.95215 22.7149 5.84533 24.0803C5.57058 24.423 5.29949 24.7693 5.01273 25.1083C4.87222 25.2791 4.74059 25.4567 4.59904 25.6306L4.17543 26.1482C3.8965 26.4966 3.61758 26.8477 3.32089 27.1929C3.03779 27.5444 2.74632 27.8955 2.42822 28.2376C2.51597 27.7826 2.62984 27.3366 2.75468 26.8931C2.88997 26.4549 3.03831 26.0208 3.19449 25.5873C3.36477 25.1631 3.53714 24.7374 3.7257 24.319C3.91426 23.9006 4.11849 23.489 4.33474 23.0832C5.20386 21.4643 6.24874 19.9461 7.45046 18.5561C8.6459 17.164 9.98629 15.9033 11.4489 14.7953C11.8187 14.5248 12.1854 14.2521 12.5683 14.0009C12.9512 13.7496 13.3377 13.5052 13.7315 13.2732C14.1254 13.0413 14.5317 12.8272 14.9428 12.6229C15.3539 12.4187 15.7785 12.2354 16.2095 12.0703"
                    fill="black"/>
                <path
                    d="M0.975197 27.9519C1.06086 27.5095 1.17368 27.0441 1.32986 26.4894L1.34031 26.4533C1.47403 26.0214 1.62498 25.5732 1.80257 25.0822L1.82086 25.0341C1.99949 24.5891 2.17656 24.153 2.37557 23.7106C2.46019 23.5246 2.54585 23.3512 2.63152 23.1783C2.63152 23.1783 2.7574 22.9223 2.78508 22.8649C2.85821 22.716 2.94178 22.5473 3.0358 22.376C3.95336 20.6651 5.05694 19.0607 6.32651 17.5919C7.59131 16.1194 9.00964 14.7859 10.5574 13.6144C10.6901 13.513 10.8316 13.4117 10.9753 13.3114L11.2996 13.079C11.4391 12.9787 11.5963 12.8648 11.7724 12.7546C12.1228 12.5263 12.5391 12.2594 12.98 11.9993L13.0098 11.9821C13.4548 11.734 13.8575 11.512 14.2843 11.2989L14.3062 11.2884C14.6718 11.115 15.1555 10.8899 15.681 10.6893L20.5141 8.8418L17.3859 12.9635C17.0521 13.4039 16.711 13.7993 16.4493 14.0933C16.1615 14.4339 15.8549 14.7849 15.5373 15.138L15.2965 15.4096C15.0876 15.6478 14.8682 15.8943 14.6431 16.1372L14.4054 16.4036C14.1902 16.6449 13.975 16.8863 13.7567 17.1224C12.6796 18.3237 11.4584 19.6818 10.3156 21.0179C9.34089 22.1514 8.31607 23.3825 6.99144 25.0133L6.85145 25.1882C6.62894 25.4666 6.39911 25.755 6.15988 26.0412C5.83185 26.4591 5.57226 26.7787 5.32101 27.0812L5.28654 27.1245C5.02224 27.4546 4.74958 27.7957 4.45707 28.1363C4.18912 28.4695 3.86788 28.8592 3.50904 29.2436L0 32.9997L0.975197 27.9519Z"
                    fill="white"/>
                <path
                    d="M18.9981 10.0006C18.6501 10.4601 18.2848 10.8899 17.9156 11.3093C17.5463 11.7287 17.1874 12.1571 16.8202 12.5668C16.4529 12.9765 16.0927 13.3978 15.7209 13.7985C15.3491 14.1992 14.9966 14.6186 14.6255 15.0186C13.1737 16.6406 11.7407 18.2439 10.3431 19.8788C8.9455 21.5138 7.57946 23.1707 6.21214 24.8586C5.87386 25.2826 5.53751 25.7104 5.18633 26.1311C4.84869 26.5601 4.50654 26.9892 4.15537 27.4151C3.80419 27.841 3.46719 28.2804 3.1012 28.7076C2.75196 29.1425 2.39241 29.5767 2 30C2.10825 29.4371 2.24872 28.8853 2.40272 28.3366C2.56961 27.7944 2.75261 27.2574 2.94527 26.7211C3.15533 26.1963 3.36796 25.6696 3.60058 25.152C3.71785 24.8935 3.84479 24.6409 3.96915 24.3862C4.09351 24.1316 4.21465 23.8738 4.35254 23.6269C5.42307 21.623 6.71169 19.7441 8.19482 18.0248C9.6689 16.3017 11.3227 14.7419 13.128 13.372C13.3522 13.2007 13.5848 13.0392 13.8136 12.8731C14.0423 12.707 14.2646 12.539 14.5082 12.3884C14.9818 12.0796 15.4573 11.7752 15.9432 11.4883C16.429 11.2013 16.9303 10.9364 17.4374 10.6837C17.9445 10.431 18.4684 10.2042 19 10"
                    fill="black"/>
            </g>
        </svg>
    );
};

export const PdfIcon = () => {
    return (
        <svg
            width="29"
            height="38"
            viewBox="0 0 29 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_118_923"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="29"
                height="38">
                <path d="M28.9936 0H0V37.4893H28.9936V0Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_118_923)">
                <path
                    d="M23.9985 20.3096H8.38359C8.20131 20.3096 8.02649 20.382 7.8976 20.5109C7.7687 20.6398 7.69629 20.8146 7.69629 20.9969C7.69629 21.1792 7.7687 21.354 7.8976 21.4829C8.02649 21.6118 8.20131 21.6842 8.38359 21.6842H23.9985C24.1808 21.6842 24.3556 21.6118 24.4845 21.4829C24.6134 21.354 24.6858 21.1792 24.6858 20.9969C24.6858 20.8146 24.6134 20.6398 24.4845 20.5109C24.3556 20.382 24.1808 20.3096 23.9985 20.3096Z"
                    fill="black"/>
                <path
                    d="M23.9995 16.3096H8.38456C8.19399 16.3096 8.01123 16.3853 7.87647 16.52C7.74172 16.6548 7.66602 16.8375 7.66602 17.0281C7.66602 17.2187 7.74172 17.4014 7.87647 17.5362C8.01123 17.671 8.19399 17.7467 8.38456 17.7467H23.9995C24.1901 17.7467 24.3728 17.671 24.5076 17.5362C24.6423 17.4014 24.718 17.2187 24.718 17.0281C24.718 16.8375 24.6423 16.6548 24.5076 16.52C24.3728 16.3853 24.1901 16.3096 23.9995 16.3096Z"
                    fill="black"/>
                <path
                    d="M3.70442 7.06543C3.57945 7.06543 3.43699 7.06855 3.37451 7.07543V8.31757C3.46656 8.33327 3.55981 8.34079 3.65318 8.34007C4.52793 8.34007 4.6279 7.98454 4.6279 7.67525C4.6279 7.49281 4.63665 7.06543 3.70442 7.06543Z"
                    fill="black"/>
                <path
                    d="M7.69324 7.06668C7.56265 7.06668 7.37395 7.07855 7.12402 7.10104V10.0733C7.37395 10.0814 7.44643 10.0852 7.647 10.0852C7.86075 10.1042 8.07566 10.0649 8.26886 9.97149C8.46206 9.87808 8.62633 9.73405 8.74419 9.55472C8.93075 9.23087 9.02235 8.86102 9.00849 8.48752C9.00849 7.51718 8.59423 7.06543 7.69636 7.06543"
                    fill="black"/>
                <path
                    d="M15.8705 6.05048C15.8703 5.58996 15.6873 5.14833 15.3618 4.82264C15.0362 4.49694 14.5946 4.31381 14.1341 4.31348H1.737C1.27637 4.31364 0.834655 4.4967 0.50894 4.82242C0.183224 5.14813 0.000165605 5.58985 0 6.05048L0 11.074C0.000165605 11.5347 0.183224 11.9764 0.50894 12.3021C0.834655 12.6278 1.27637 12.8109 1.737 12.8111H14.1341C14.5947 12.8109 15.0364 12.6278 15.3622 12.3021C15.6879 11.9764 15.8709 11.5347 15.8711 11.074L15.8705 6.05048ZM5.06106 8.86218C4.63041 9.1698 4.1089 9.32384 3.58023 9.29956C3.51018 9.30112 3.44009 9.29883 3.37029 9.29268V11.0616H2.31184V6.25542L2.49304 6.22293C2.89084 6.15237 3.29372 6.11434 3.6977 6.10921C4.20258 6.08271 4.70146 6.22881 5.11229 6.52347C5.28659 6.65404 5.42751 6.82401 5.52351 7.01949C5.61951 7.21497 5.66787 7.43039 5.66463 7.64815C5.67007 7.88372 5.61834 8.1171 5.51388 8.32831C5.40941 8.53952 5.25533 8.72228 5.06481 8.86093M9.53478 10.2299C9.28939 10.5107 8.9821 10.7305 8.63717 10.8721C8.29223 11.0138 7.9191 11.0733 7.54722 11.0459C7.2848 11.0459 6.88241 11.0153 6.29758 10.9522L6.12325 10.9328V6.25417L6.29383 6.23105C7.01175 6.1492 7.44475 6.10921 7.70155 6.10921C8.04888 6.08418 8.3973 6.13972 8.71963 6.27152C9.04196 6.40331 9.32948 6.60778 9.55977 6.869C9.91049 7.33577 10.0873 7.91034 10.0596 8.49354C10.0907 9.11686 9.90604 9.73186 9.53665 10.2349M13.6211 7.12517H11.5592V7.99993H13.4961V9.06212H11.5592V11.0616H10.4345V6.12546H13.6211V7.12517Z"
                    fill="black"/>
                <path
                    d="M17.6192 0H5.15155C4.92262 0.00325555 4.69659 0.0516386 4.48639 0.142378C4.27619 0.233118 4.08595 0.364432 3.92657 0.528801C3.7672 0.693169 3.64181 0.887362 3.55759 1.10026C3.47337 1.31316 3.43198 1.54058 3.43579 1.7695V3.499H4.87288V2.60176C4.86753 2.45188 4.89222 2.30245 4.94548 2.16226C4.99875 2.02207 5.07951 1.89394 5.18302 1.78542C5.28654 1.6769 5.41071 1.59018 5.54823 1.53036C5.68575 1.47054 5.83385 1.43883 5.98381 1.43709H17.6192V9.62226C17.6179 10.0835 17.7993 10.5266 18.1238 10.8544C18.4483 11.1823 18.8894 11.3683 19.3506 11.3718H27.5539V31.516C27.5505 31.8256 27.4253 32.1214 27.2055 32.3395C26.9857 32.5575 26.6889 32.6803 26.3792 32.6813H21.1745C21.1344 32.7464 21.0904 32.809 21.0426 32.8687L20.1185 34.0528H27.2128C27.6746 34.0622 28.1213 33.8879 28.4547 33.5681C28.7881 33.2484 28.981 32.8095 28.991 32.3476V11.3718L17.6192 0Z"
                    fill="black"/>
                <path
                    d="M11.2208 32.6811H5.98419C5.83417 32.6794 5.68602 32.6476 5.54846 32.5878C5.41089 32.5279 5.28669 32.4411 5.18317 32.3326C5.07965 32.224 4.9989 32.0958 4.94567 31.9555C4.89245 31.8152 4.86783 31.6657 4.87325 31.5158V13.6865H3.43616V32.3493C3.43337 32.575 3.4759 32.799 3.56124 33.008C3.64658 33.217 3.77299 33.4067 3.93298 33.5659C4.09298 33.7252 4.2833 33.8507 4.49268 33.935C4.70205 34.0194 4.92623 34.0608 5.15192 34.057H12.2793L11.3545 32.8742C11.3063 32.813 11.2618 32.749 11.2214 32.6824"
                    fill="black"/>
                <path
                    d="M20.0026 31.6181H18.1219V25.2574C18.1268 25.0481 18.0501 24.845 17.9081 24.6911C17.7662 24.5372 17.5699 24.4446 17.3609 24.4326H15.0378C14.8256 24.4436 14.6255 24.5351 14.4784 24.6884C14.3313 24.8418 14.2482 25.0455 14.2461 25.258V31.6181H12.3967C12.3126 31.6194 12.2304 31.6437 12.1592 31.6884C12.0879 31.7331 12.0303 31.7964 11.9925 31.8716C11.9547 31.9467 11.9382 32.0308 11.9448 32.1146C11.9514 32.1985 11.9808 32.2789 12.0299 32.3472L15.8332 37.3077C15.8763 37.3635 15.9315 37.4088 15.9946 37.4403C16.0577 37.4718 16.127 37.4887 16.1975 37.4897C16.2681 37.4906 16.3379 37.4756 16.4018 37.4459C16.4657 37.4161 16.5221 37.3723 16.5667 37.3177L20.3694 32.3429C20.4185 32.2749 20.4479 32.1948 20.4545 32.1112C20.461 32.0276 20.4445 31.9438 20.4066 31.8691C20.3687 31.7943 20.311 31.7314 20.2397 31.6872C20.1685 31.643 20.0864 31.6193 20.0026 31.6187"
                    fill="black"/>
            </g>
        </svg>
    );
};

export const TextIcon = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M4.56432 0.489258H0V5.05358H4.56432V0.489258Z" fill="black"/>
            <path d="M31.225 0.489258H26.6606V5.05358H31.225V0.489258Z" fill="black"/>
            <path d="M4.56432 27.1514H0V31.7157H4.56432V27.1514Z" fill="black"/>
            <path d="M31.225 27.1514H26.6606V31.7157H31.225V27.1514Z" fill="black"/>
            <mask
                id="mask0_118_935"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="31"
                height="32">
                <path d="M30.8748 0.830078H0V31.7048H30.8748V0.830078Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_118_935)">
                <path
                    d="M29.7778 7.24805V9.23285"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M29.7778 11.166V13.1508"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M29.7778 15.0879V17.0727"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M29.7778 19.0088V20.9936"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M29.7778 22.9277V24.9125"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M24.4619 30.2607H22.4771"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M20.5414 30.2607H18.5566"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M16.6201 30.2607H14.6353"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M12.6992 30.2607H10.7144"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M8.77777 30.2607H6.79297"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M1.44678 24.9428V22.958"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M1.44678 21.0239V19.0391"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M1.44678 17.103V15.1182"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M1.44678 13.1811V11.1963"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M1.44678 9.26313V7.27832"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M6.76318 1.92969H8.74799"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M10.6836 1.92969H12.6684"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M14.6055 1.92969H16.5903"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M18.5259 1.92969H20.5107"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
                <path
                    d="M22.4468 1.92969H24.4316"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeDasharray="23.1 23.1 23.1 23.1 23.1 23.1"/>
            </g>
            <path d="M17.6665 8.20117H13.5293V24.8375H17.6665V8.20117Z" fill="black"/>
            <path d="M25.4299 7.20508H5.76709V9.3222H25.4299V7.20508Z" fill="black"/>
            <path d="M20.498 23.7109H10.6953V25.8317H20.498V23.7109Z" fill="black"/>
            <path d="M25.4106 7.20508H23.2935V12.6273H25.4106V7.20508Z" fill="black"/>
            <path d="M7.88422 7.20508H5.76709V12.6273H7.88422V7.20508Z" fill="black"/>
        </svg>

    );
};

export const UserIcon = () => {
    return (
        <svg
            width="22"
            height="28"
            viewBox="0 0 22 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.162 12.0799C14.0612 12.0799 16.4115 9.72967 16.4115 6.83049C16.4115 3.93131 14.0612 1.58105 11.162 1.58105C8.26285 1.58105 5.9126 3.93131 5.9126 6.83049C5.9126 9.72967 8.26285 12.0799 11.162 12.0799Z"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
            <path
                d="M14.1546 15.2295H8.16875C6.35308 15.2295 4.61177 15.9508 3.3279 17.2346C2.04403 18.5185 1.32275 20.2598 1.32275 22.0755V25.3337C1.32275 25.4666 1.34892 25.5982 1.39977 25.7209C1.45061 25.8436 1.52513 25.9552 1.61908 26.0491C1.71302 26.1431 1.82455 26.2176 1.9473 26.2684C2.07005 26.3193 2.20161 26.3454 2.33447 26.3454H19.9882C20.1211 26.3454 20.2526 26.3193 20.3754 26.2684C20.4981 26.2176 20.6096 26.1431 20.7036 26.0491C20.7975 25.9552 20.8721 25.8436 20.9229 25.7209C20.9737 25.5982 20.9999 25.4666 20.9999 25.3337V22.0755C20.9999 20.2599 20.2787 18.5187 18.995 17.2349C17.7113 15.951 15.9701 15.2297 14.1546 15.2295Z"
                stroke="black"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>

    );
}

export const MenuIcon = () => { return (<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"> <path d="M135 4404 c-84 -31 -135 -108 -135 -204 0 -100 58 -181 149 -209 55 -16 4767 -16 4822 0 91 28 149 109 149 209 0 98 -51 174 -139 205 -39 13 -306 15 -2425 14 -2056 0 -2386 -2 -2421 -15z" /> <path d="M109 2757 c-24 -13 -57 -43 -74 -66 -28 -39 -30 -50 -30 -126 0 -76 2 -87 30 -126 17 -23 50 -53 74 -66 l44 -23 2407 0 2407 0 44 23 c24 13 58 43 74 66 28 39 30 50 30 126 0 76 -2 87 -30 126 -16 23 -50 53 -74 66 l-44 23 -2407 0 -2407 0 -44 -23z" /> <path d="M147 1137 c-91 -29 -147 -107 -147 -207 0 -99 61 -185 147 -209 53 -15 4773 -15 4826 0 86 24 147 110 147 209 0 103 -61 185 -156 209 -64 16 -4765 14 -4817 -2z" /> </g> </svg>) }


export const MenuCLose = () => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">
            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M132 5094 c-87 -43 -132 -121 -132 -226 0 -41 7 -79 21 -108 15 -35
258 -283 1097 -1122 l1077 -1078 -1081 -1082 c-1201 -1203 -1120 -1112 -1112
-1246 7 -135 95 -223 230 -230 134 -8 43 -89 1246 1112 l1082 1081 1083 -1081
c1202 -1201 1111 -1120 1245 -1112 135 7 223 95 230 230 8 134 89 43 -1112
1245 l-1081 1083 1081 1083 c1201 1202 1120 1111 1112 1245 -7 135 -95 223
-230 230 -134 8 -43 89 -1246 -1112 l-1082 -1081 -1078 1077 c-839 839 -1087
1082 -1122 1097 -67 31 -161 28 -228 -5z"/>
            </g>
        </svg>
    )
}

export const PlusIcon = () => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.42088 0.0498409C6.10271 0.222496 4.8742 0.684021 3.78514 1.41449C2.02537 2.5932 0.770292 4.3596 0.249003 6.39164C0.0730263 7.07562 0.0265419 7.43753 0.00994039 8.30082C-0.00334086 8.90511 0.00662007 9.18402 0.0464638 9.52933C0.368534 12.1856 1.91248 14.5131 4.24998 15.8811C5.09998 16.3758 6.07283 16.7244 7.11873 16.9071C7.69646 17.0067 8.92166 17.0299 9.5326 16.9502C13.1916 16.492 16.1201 13.7793 16.8506 10.1768C17.0066 9.41312 17.0465 8.23773 16.9502 7.43753C16.472 3.59593 13.4041 0.527966 9.56248 0.0498409C9.05779 -0.00992584 7.899 -0.00992584 7.42088 0.0498409ZM9.46287 1.14886C12.1357 1.48422 14.4998 3.36351 15.4494 5.91019C15.964 7.28812 16.0504 8.89183 15.6885 10.3129C15.0244 12.9094 13.0189 14.9481 10.4324 15.6586C8.9615 16.0604 7.28806 15.9774 5.85701 15.4295C3.649 14.5828 1.94236 12.6836 1.3281 10.386C1.01267 9.20062 1.01267 7.79945 1.3281 6.6141C1.67674 5.31253 2.37732 4.11722 3.34021 3.18754C4.99041 1.59047 7.18181 0.863317 9.46287 1.14886Z" fill="white"/>
<path d="M8.20781 3.85156C8.14805 3.88809 8.07168 3.96445 8.03516 4.02422C7.97207 4.13047 7.96875 4.19687 7.96875 6.04961V7.96875H6.05293C4.19688 7.96875 4.13047 7.97207 4.02422 8.03516C3.86484 8.13477 3.78516 8.28418 3.78516 8.5C3.78516 8.71582 3.86484 8.86523 4.02422 8.96484C4.13047 9.02793 4.19688 9.03125 6.05293 9.03125H7.96875V10.9471C7.96875 12.8031 7.97207 12.8695 8.03516 12.9758C8.13477 13.1352 8.28418 13.2148 8.5 13.2148C8.71582 13.2148 8.86523 13.1352 8.96484 12.9758C9.02793 12.8695 9.03125 12.8031 9.03125 10.9471V9.03125H10.9504C12.8031 9.03125 12.8695 9.02793 12.9758 8.96484C13.1352 8.86523 13.2148 8.71582 13.2148 8.5C13.2148 8.28418 13.1352 8.13477 12.9758 8.03516C12.8695 7.97207 12.8031 7.96875 10.9504 7.96875H9.03125V6.04961C9.03125 4.19687 9.02793 4.13047 8.96484 4.02422C8.86523 3.86484 8.71582 3.78516 8.5 3.78516C8.37715 3.78516 8.28086 3.80508 8.20781 3.85156Z" fill="white"/>
</svg>
    )
}
